import Error from '../model/Error';
import axios from 'axios';

export default class PhysicalAccessTerminalRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/physical-access/terminals`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(id, name, effect, filterFlagId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/physical-access-terminals/${id}`, { name, effect, filterFlagId })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
